import { render, staticRenderFns } from "./chooseTaskType.vue?vue&type=template&id=e04a3bf4&scoped=true&"
import script from "./chooseTaskType.vue?vue&type=script&lang=js&"
export * from "./chooseTaskType.vue?vue&type=script&lang=js&"
import style0 from "./chooseTaskType.vue?vue&type=style&index=0&id=e04a3bf4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04a3bf4",
  null
  
)

export default component.exports